import { render, staticRenderFns } from "./IconCommoUnpin.vue?vue&type=template&id=38008fe7"
import script from "./IconCommoUnpin.vue?vue&type=script&lang=js"
export * from "./IconCommoUnpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports